module.exports = __webpack_public_path__ + "img/icon-system.1b1c5f44.svg";